/* WPS refresh: wishlist kept in the shopper's browser (no app, no account needed).
   - [data-wps-wish="<handle>"] buttons toggle a product (hearts on product cards).
   - [data-wps-wish-count] shows the number of saved products (header heart).
   - [data-wps-wishlist] is the wishlist page: it holds every product card, hidden,
     and shows the saved ones in the order they were added (newest first). */
(function () {
  'use strict';

  var KEY = 'wps-wishlist';

  function read() {
    try {
      var v = JSON.parse(window.localStorage.getItem(KEY) || '[]');
      return Array.isArray(v) ? v.filter(function (h) { return typeof h === 'string' && h; }) : [];
    } catch (e) { return []; }
  }
  function write(list) {
    try { window.localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) { /* private mode: keep it for this page only */ }
    memory = list;
  }
  var memory = read();
  function list() { var l = read(); return l.length || !memory.length ? l : memory; }

  function has(handle) { return list().indexOf(handle) > -1; }

  function toggle(handle) {
    var l = list().filter(function (h) { return h !== handle; });
    var added = l.length === list().length;
    if (added) l.unshift(handle);
    write(l);
    sync();
    document.dispatchEvent(new CustomEvent('wps:wishlist', { detail: { handle: handle, added: added, count: l.length } }));
    return added;
  }

  function label(btn, on) {
    var name = btn.getAttribute('data-title') || 'this wine';
    btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    btn.setAttribute('aria-label', (on ? 'Remove ' : 'Save ') + name + (on ? ' from your wishlist' : ' to your wishlist'));
    btn.title = on ? 'Remove from wishlist' : 'Save to wishlist';
  }

  function sync() {
    var l = list();
    document.querySelectorAll('[data-wps-wish]').forEach(function (btn) {
      var on = l.indexOf(btn.getAttribute('data-wps-wish')) > -1;
      btn.classList.toggle('is-on', on);
      label(btn, on);
    });
    document.querySelectorAll('[data-wps-wish-count]').forEach(function (el) {
      el.textContent = l.length;
      el.hidden = l.length === 0;
    });
    renderPage(l);
  }

  // Wishlist page.
  function renderPage(l) {
    var page = document.querySelector('[data-wps-wishlist]');
    if (!page) return;
    var grid = page.querySelector('[data-wps-wishlist-grid]');
    var items = {};
    grid.querySelectorAll('[data-wps-wish-item]').forEach(function (it) { items[it.getAttribute('data-wps-wish-item')] = it; it.hidden = true; });
    var shown = 0;
    l.forEach(function (h) {
      var it = items[h];
      if (!it) return;
      it.hidden = false;
      grid.appendChild(it); // keep the saved order
      shown++;
    });
    page.querySelector('[data-wps-wishlist-empty]').hidden = shown > 0;
    var n = page.querySelector('[data-wps-wishlist-n]');
    if (n) n.textContent = shown ? shown + (shown === 1 ? ' wine saved' : ' wines saved') : '';
    var clear = page.querySelector('[data-wps-wishlist-clear]');
    if (clear) clear.hidden = shown === 0;
    page.classList.add('is-ready');
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-wps-wish]');
    if (btn) {
      e.preventDefault();
      e.stopPropagation();
      var added = toggle(btn.getAttribute('data-wps-wish'));
      btn.classList.remove('is-pop');
      if (added) { void btn.offsetWidth; btn.classList.add('is-pop'); }
      return;
    }
    if (e.target.closest('[data-wps-wishlist-clear]')) {
      e.preventDefault();
      write([]);
      sync();
    }
  }, true);

  // Keep other tabs in step.
  window.addEventListener('storage', function (e) { if (e.key === KEY) { memory = read(); sync(); } });
  // Cards added later (load more, quick view, search) pick up their state.
  document.addEventListener('wps:render', sync);

  window.wpsWishlist = { list: list, has: has, toggle: toggle, sync: sync };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', sync);
  else sync();
})();
